import React from 'react';
import { Bot, MessageCircle, Globe, Calendar, FileText } from 'lucide-react';
import { LeadRealSource } from '../types/leadFormData';
import { getLeadSourceInfo } from '../utils/leadFormDataParser';

interface LeadSourceBadgeProps {
  source: LeadRealSource;
  showIcon?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const LeadSourceBadge: React.FC<LeadSourceBadgeProps> = ({
  source,
  showIcon = true,
  size = 'md'
}) => {
  const sourceInfo = getLeadSourceInfo(source);

  const iconMap = {
    Bot,
    MessageCircle,
    Globe,
    Calendar,
    FileText
  };

  const IconComponent = iconMap[sourceInfo.icon];

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-xs',
    lg: 'px-3 py-1.5 text-sm'
  };

  const iconSizeClasses = {
    sm: 'w-3 h-3',
    md: 'w-3.5 h-3.5',
    lg: 'w-4 h-4'
  };

  return (
    <span
      className={`inline-flex items-center space-x-1 ${sizeClasses[size]} ${sourceInfo.bgClass} ${sourceInfo.colorClass} ${sourceInfo.borderClass} border rounded-full font-medium`}
    >
      {showIcon && <IconComponent className={iconSizeClasses[size]} />}
      <span>{sourceInfo.label}</span>
    </span>
  );
};

export default LeadSourceBadge;
